import gql from 'graphql-tag';

import logoFragment from './logoFragment';

export const logosPageFragment = gql`
  fragment logosPageFragment on LogosPage {
    dokkioClass
    total
    logos {
      ...logoFragment
    }
  }
  ${logoFragment}
`;
export default logosPageFragment;
